import { render, staticRenderFns } from "./ProposalHeader.vue?vue&type=template&id=64661ba7&"
import script from "./ProposalHeader.vue?vue&type=script&lang=js&"
export * from "./ProposalHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports